import axios from 'axios';
import Swal from 'sweetalert2';
import { getSessionState } from './getSessionState';

// Books the next proctored sitting. The Assessment app remains authoritative for
// sitting state, so on success we simply re-fetch it and tell the candidate to watch
// their inbox — ProctorExam emails the new invite from its own servers.
export function beginSession({ candidateId }, callback) {
  return (dispatch) => {
    axios
      .post('/user/session', { candidateId })
      .then((response) => {
        const { status } = response.data;
        if (status === 'SUCCESS') {
          if (candidateId) dispatch(getSessionState(candidateId));
          Swal.fire({
            title: 'Next session booked',
            text: 'Check your email for a new secure invite from our proctoring partner to begin your next session.',
            icon: 'success',
            confirmButtonColor: '#3f51b5',
          }).then(() => {
            if (callback) callback();
          });
        }
      })
      .catch((error) => {
        console.error(error);
        Swal.fire({
          title: 'Could not book next session',
          text: 'Please try again shortly, or contact support if the problem persists.',
          icon: 'error',
          confirmButtonColor: '#3f51b5',
        });
      });
  };
}
